/**
 * @desc 充值列表
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.PageRequest<defs.TigerBalmTopUpQueryConditions>): Promise<BaseResponse<defs.PageBean<Array<defs.AllAccountTransactionHistory>>>> {
  return fetch({
    url: config.API_HOST + '/elecCard/wjy/rechargeList',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
